import React from 'react';
import { Animated } from "react-animated-css";
import { Link } from 'react-router';
import _ from 'lodash';

class Card extends React.Component {
    render() {
        const { index, qa, qasCategories } = this.props;
        const category = _.find(qasCategories, cat => cat.value === qa.IdCategory);
        return (
            <Animated animationIn="fadeInRight" animationInDelay={index * 50}>
                <Link to={`/admin/qas/add/${qa.id}`}>
                    <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red">
                        <span className="align-self-center font-18 text-center line1 margin-top-half anton toUpper black">{qa.Question}</span>
                        <span className="align-self-center font-12 text-center line1 margin-top-half hind blue">{(category || {}).name}</span>
                    </figure>
                </Link>
            </Animated>
        )
    }
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/private/qas/partials/card.js